module.exports = __webpack_public_path__ + "img/bed-solid.56894ae2.svg";